var site = site || {};

(function($) {
    'use strict';

    var blobCanvas = function($element, options) {
        this.$el = $element;
    this.renderIID = -1;
    this.startTS = new Date().getTime();
    this.changingColor = false;
    this.colorChangeStart = null;
    this.colorOld = '';

    this.options = $.extend({
      color: 'blue',
      colorPeriod: 500,
      pulsePeriod: 5000,
      mouseHalo: 20,
      wanderPoint: 0.5,
      wanderControl: 1,
      type: 'normal',
      links: false
    }, options || {})
        this.initialize();
    };

    blobCanvas.prototype.initialize = function() {
    var self = this;

    this.size = { width: this.$el.width(), height: this.$el.height() };
    this.$canvas = $('<canvas width="'+ this.size.width +'" height="'+ this.size.height +'"></canvas>').appendTo(this.$el);
    // this.$canvas = $('<canvas></canvas>').appendTo(this.$el);

    this.ctx = this.$canvas.get(0).getContext("2d");
    this.ctx.lineWidth = 1;

    var factor = this.size.height / 256;
    if (this.size.width / 290 < factor ) { factor = this.size.width / 290; }

    this.options.wanderPoint = this.options.wanderPoint * factor;
    this.options.wanderControl = this.options.wanderControl * factor;
    this.options.mouseHalo = this.options.mouseHalo * factor * this.options.mouseHalo * factor;

    this.colorSet = {
      'orange': [ '#dfecc3', '#eae473', '#f6d21f', '#f6903b', '#f16940' ],
      'blue': ['#dfecc3', '#a0d2a9', '#39ada8', '#557b83','#29303b'],
      'green': [ '#dfecc3', '#b8d08e', '#bed774', '#68764a', '#2e4a2e' ],
      'red': [ '#dce5c1', '#d48788', '#b37083', '#685c78', '#3e5c7a' ],
      'purple': [ '#dfe8c4', '#bdbedd', '#8c63c5', '#574f94', '#3c3349' ],
      'purpleServices': ['#3e324a', '#45279b', '#574b97', '#935fcc', '#bbbcdd']
    };

    this.nodesOriginal = [
      { x:27.8 * factor, y:89.9 * factor, cx:30.8 * factor, cy:40.4 * factor }, //0
      { x:82.5 * factor, y:29.9 * factor, cx:109.5 * factor, cy:30.9 * factor },
      { x:166.5 * factor, y:26.2 * factor, cx:180.2 * factor, cy:25.9 * factor }, //2
      { x:229.2 * factor, y:62.3 * factor, cx:258.2 * factor, cy:99.5 * factor },
      { x:269.8 * factor, y:129.5 * factor, cx:268.2 * factor, cy:149.2 * factor }, //4
      { x:249.8 * factor, y:169.5 * factor, cx:237.2 * factor, cy:174.9 * factor },
      { x:203.2 * factor, y:206.2 * factor, cx:179.2 * factor, cy:242.6 * factor }, //6
      { x:69.2 * factor, y:206.2 * factor, cx:30.8 * factor, cy:164.2 * factor },

      { x:33.3 * factor, y:119.9 * factor, cx:31.6 * factor, cy:95.4 * factor },
      { x:49.5 * factor, y:54.5 * factor, cx:58.3 * factor, cy:38.9 * factor },
      { x:111.5 * factor, y:37.5 * factor, cx:138.5 * factor, cy:35.8 * factor },
      { x:181.5 * factor, y:37.5 * factor, cx:194.5 * factor, cy:46.5 * factor },
      { x:230.5 * factor, y:90.8 * factor, cx:249.5 * factor, cy:113.2 * factor },
      { x:237.8 * factor, y:158.8 * factor, cx:209.5 * factor, cy:180.5 * factor },
      { x:184.5 * factor, y:207.5 * factor, cx:169.5 * factor, cy:230.8 * factor },
      { x:74.8 * factor, y:201.2 * factor, cx:50.3 * factor, cy:181.1 * factor },

      { x:41.2 * factor, y:104.5 * factor, cx:38.4 * factor, cy:69.3 * factor },
      { x:90.5 * factor, y:52.5 * factor, cx:107.5 * factor, cy:51.2 * factor },
      { x:133.2 * factor, y:45.5 * factor, cx:156.5 * factor, cy:40.5 * factor },
      { x:193.4 * factor, y:65.8 * factor, cx:201.0 * factor, cy:86.2 * factor },
      { x:234.9 * factor, y:125.1 * factor, cx:236.6 * factor, cy:146.1 * factor },
      { x:197.8 * factor, y:167.9 * factor, cx:190.8 * factor, cy:175.6 * factor },
      { x:164.8 * factor, y:202.9 * factor, cx:146.5 * factor, cy:215.6 * factor },
      { x:84.5 * factor, y:193.7 * factor, cx:42.2 * factor, cy:176.1 * factor },

      { x:54.9 * factor, y:98.3 * factor, cx:54.1 * factor, cy:74.6 * factor },
      { x:90.8 * factor, y:65.5 * factor, cx:106.8 * factor, cy:62.1 * factor },
      { x:145.5 * factor, y:62.9 * factor, cx:174.8 * factor, cy:57.2 * factor },
      { x:185.2 * factor, y:99.2 * factor, cx:197.2 * factor, cy:118.5 * factor },
      { x:190.2 * factor, y:132.9 * factor, cx:186.1 * factor, cy:139.3 * factor },
      { x:170.8 * factor, y:164.2 * factor, cx:165.2 * factor, cy:174.2 * factor },
      { x:129.3 * factor, y:190.6 * factor, cx:91.3 * factor, cy:185.9 * factor },
      { x:58.8 * factor, y:146.5 * factor, cx:49.8 * factor, cy:131.9 * factor },

      { x:69.5 * factor, y:109.0 * factor, cx:69.6 * factor, cy:100.9 * factor },
      { x:85.2 * factor, y:86.3 * factor, cx:93.6 * factor, cy:82.4 * factor },
      { x:116.4 * factor, y:93.4 * factor, cx:125.6 * factor, cy:101.4 * factor },
      { x:137.5 * factor, y:123.9 * factor, cx:141.1 * factor, cy:136.1 * factor },
      { x:145.1 * factor, y:158.0 * factor, cx:142.6 * factor, cy:167.1 * factor },
      { x:126.5 * factor, y:172.1 * factor, cx:114.7 * factor, cy:173.5 * factor },
      { x:94.1 * factor, y:165.2 * factor, cx:87.3 * factor, cy:160.2 * factor },
      { x:72.8 * factor, y:143.6 * factor, cx:67.7 * factor, cy:130.4 * factor },
    ];

    if (this.options.type.length > 0 && this.options.type == 'services') {
    this.nodesOriginal = [
      {x:306.31 * factor,y:272.22 * factor,cx:285.62 * factor,cy:301.14 * factor},{x:223.56 * factor,y:315.95 * factor,cx:175.37 * factor,cy:334.52 * factor},{x:144.58 * factor,y:343.92 * factor,cx:122.01 * factor,cy:351.21 * factor},{x:32.21 * factor,y:284.68 * factor,cx:13.87 * factor,cy:277.16 * factor},{x:5.17 * factor,y:231.32 * factor,cx:6.82 * factor,cy:212.28 * factor},{x:32.44 * factor,y:192.06 * factor,cx:54.3 * factor,cy:166.91 * factor},{x:76.87 * factor,y:96.62 * factor,cx:156.8 * factor,cy:67.47 * factor},{x:271.05 * factor,y:138.93 * factor,cx:284.45 * factor,cy:148.34 * factor},

      {x:257.65 * factor,y:287.74 * factor,cx:222.39 * factor,cy:294.32 * factor},{x:182.42 * factor,y:308.9 * factor,cx:153.98 * factor,cy:328.41 * factor},{x:106.02 * factor,y:315.95 * factor,cx:81.81 * factor,cy:294.09 * factor},{x:43.73 * factor,y:268.23 * factor,cx:19.98 * factor,cy:251.3 * factor},{x:34.56 * factor,y:204.99 * factor,cx:55.95 * factor,cy:189.01 * factor},{x:76.17 * factor,y:151.63 * factor,cx:76.87 * factor,cy:135.64 * factor},{x:130.24 * factor,y:106.26 * factor,cx:178.9 * factor,cy:107.67 * factor},{x:256.24 * factor,y:159.15 * factor,cx:275.75 * factor,cy:213.22 * factor},

      {x:240.49 * factor,y:182.19 * factor,cx:228.97 * factor,cy:140.58 * factor},{x:130.71 * factor,y:132.59 * factor,cx:109.08 * factor,cy:134.7 * factor},{x:79.22 * factor,y:171.84 * factor,cx:75.93 * factor,cy:189.01 * factor},{x:66.29 * factor,y:208.99 * factor,cx:25.86 * factor,cy:244.25 * factor},{x:68.17 * factor,y:276.22 * factor,cx:93.56 * factor,cy:282.33 * factor},{x:122.01 * factor,y:318.3 * factor,cx:153.74 * factor,cy:313.83 * factor},{x:198.88 * factor,y:288.68 * factor,cx:200.99 * factor,cy:287.27 * factor},{x:235.32 * factor,y:273.64 * factor,cx:266.58 * factor,cy:246.84 * factor},

      {x:237.2 * factor,y:216.98 * factor,cx:238.14 * factor,cy:198.64 * factor},{x:210.63 * factor,y:173.49 * factor,cx:157.97 * factor,cy:148.34 * factor},{x:104.14 * factor,y:173.73 * factor,cx:104.61 * factor,cy:189.24 * factor},{x:98.97 * factor,y:213.45 * factor,cx:92.86 * factor,cy:233.44 * factor},{x:89.1 * factor,y:246.6 * factor,cx:87.92 * factor,cy:257.18 * factor},{x:124.83 * factor,y:290.33 * factor,cx:129.77 * factor,cy:314.54 * factor},{x:187.83 * factor,y:284.92 * factor,cx:199.82 * factor,cy:288.92 * factor},{x:222.15 * factor,y:276.69 * factor,cx:252.48 * factor,cy:263.29 * factor},

      {x:209.22 * factor,y:216.51 * factor,cx:205.7 * factor,cy:208.52 * factor},{x:197.47 * factor,y:197.23 * factor,cx:194.18 * factor,cy:193.24 * factor},{x:185.71 * factor,y:187.6 * factor,cx:180.31 * factor,cy:186.42 * factor},{x:161.97 * factor,y:181.25 * factor,cx:148.57 * factor,cy:181.01 * factor},{x:126.24 * factor,y:190.89 * factor,cx:114.72 * factor,cy:198.41 * factor},{x:115.19 * factor,y:228.5 * factor,cx:138.46 * factor,cy:243.78 * factor},{x:166.67 * factor,y:260.94 * factor,cx:188.54 * factor,cy:270.34 * factor},{x:214.16 * factor,y:251.3 * factor,cx:219.1 * factor,cy:235.79 * factor},
    ];
    }

    this.nodeCount = 8;
    this.loopCount = 5;
    this.nodesTarget = $.extend(true, [], this.nodesOriginal );
    this.nodes = $.extend(true, [], this.nodesOriginal );

    this.rendererStart();
    this.render();

    this.$el
      .on('mouseenter', function(e){
        self.$el.on('mousemove', function(e){ self.mouseMove(e); });
      })
      .on('mouseleave', function(e){
        self.$el.off('mousemove');
        self.nodesTarget = $.extend(true, [], self.nodesOriginal );
      })
      .on('mouseup', function(e){
        self.mouseClick(e);
      });

    };

  blobCanvas.prototype.changeColor = function(newColor) {
    if (!this.colorSet[newColor] || newColor === this.options.color) { return; }

    this.changingColor = true;
    this.colorChangeStart = new Date().getTime();
    this.colorOld = this.options.color;
    this.options.color = newColor;
  };

  blobCanvas.prototype.mouseMove = function(e) {
    var i, ilen,
      canvasOffset = this.$el.offset(),
      mouse = { x:e.pageX - canvasOffset.left, y:e.pageY - canvasOffset.top },
      delta = { x:0, y:0, cx:0, cy:0 },
      factor = 1,
      sqDist = 0,
      halo = 200,
      node, nodeOriginal,
      mouseHalo = this.options.mouseHalo;

    for (i=0,ilen=this.nodesTarget.length; i<ilen; i++) {
      node = this.nodesTarget[i];
      nodeOriginal = this.nodesOriginal[i];

      delta.x = nodeOriginal.x - mouse.x;
      delta.y = nodeOriginal.y - mouse.y;
      delta.cx = nodeOriginal.cx - mouse.x;
      delta.cy = nodeOriginal.cy - mouse.y;

      sqDist = (delta.x * delta.x) + (delta.y * delta.y);
      factor = (mouseHalo > sqDist)?1:mouseHalo / sqDist;

      node.x = nodeOriginal.x + (factor * delta.x);
      node.y = nodeOriginal.y + (factor * delta.y);

      sqDist = (delta.cx * delta.cx) + (delta.cy * delta.cy);
      factor = (mouseHalo > sqDist)?1:mouseHalo / sqDist;

      node.cx = nodeOriginal.cx + (factor * delta.cx);
      node.cy = nodeOriginal.cy + (factor * delta.cy);
    }

  };

  blobCanvas.prototype.mouseClick = function(e) {
    if (!this.options.links || this.options.links.length < 0) {
      return false;
    }

    var i, ilen,
        canvasOffset = this.$el.offset(),
        mouse = { x:e.pageX - canvasOffset.left, y:e.pageY - canvasOffset.top },
        delta = { x:0, y:0, cx:0, cy:0 },
        factor = 1,
        sqDist = 0,
        halo = 200,
        node, nodeOriginal,
        mouseHalo = this.options.mouseHalo;

    function rgbToHex(r, g, b) {
      if (r > 255 || g > 255 || b > 255)
        throw "Invalid color component";
      return ((r << 16) | (g << 8) | b).toString(16);
    }

    function color_meter(cwith, ccolor) {

      if (!cwith && !ccolor) return;

      var _cwith  = (cwith.charAt(0)=="#") ? cwith.substring(1,7) : cwith;
      var _ccolor = (ccolor.charAt(0)=="#") ? ccolor.substring(1,7) : ccolor;

      var _r = parseInt(_cwith.substring(0,2), 16);
      var _g = parseInt(_cwith.substring(2,4), 16);
      var _b = parseInt(_cwith.substring(4,6), 16);

      var __r = parseInt(_ccolor.substring(0,2), 16);
      var __g = parseInt(_ccolor.substring(2,4), 16);
      var __b = parseInt(_ccolor.substring(4,6), 16);

      var p1 = (_r / 255) * 100;
      var p2 = (_g / 255) * 100;
      var p3 = (_b / 255) * 100;

      var perc1 = Math.round((p1 + p2 + p3) / 3);

      p1 = (__r / 255) * 100;
      p2 = (__g / 255) * 100;
      p3 = (__b / 255) * 100;

      var perc2 = Math.round((p1 + p2 + p3) / 3);

      return Math.abs(perc1 - perc2);
    }

    var pixel = this.ctx.getImageData(mouse.x, mouse.y, 1, 1).data;
    var color = "#" + ("000000" + rgbToHex(pixel[0], pixel[1], pixel[2])).slice(-6);

    if (color == "#000000") {
      return false;
    }

    var linkIndex = -1;
    if (this.colorSet[this.options.color].indexOf(color) >= 0) {
      linkIndex = this.colorSet[this.options.color].indexOf(color);
    } else {
      var closeness = [];
      for (var colori = 0; colori < this.colorSet[this.options.color].length; colori++) {
        closeness[colori] = color_meter(color, this.colorSet[this.options.color][colori]);
      }
      var min = Math.min.apply(Math, closeness);
      linkIndex = closeness.indexOf(min);
    }
    // console.log(jQuery(this.options.links).eq(linkIndex));
    jQuery(this.options.links).eq(linkIndex).click();
  };

  blobCanvas.prototype.rendererStart = function() {
    var self = this;
    clearInterval(this.renderIID);
    this.renderIID = setInterval(function(){ self.render(); }, 50);
  };

  blobCanvas.prototype.rendererStop = function() {
    clearInterval(this.renderIID);
  };

  blobCanvas.prototype.render = function() {
    var i, ilen,
      newTS = new Date().getTime(),
      timeDelta = newTS - this.startTS,
      angle = ( timeDelta % this.options.pulsePeriod ) * 2*Math.PI / this.options.pulsePeriod,
      sin = Math.sin( angle ),
      cos = Math.cos( angle ),
      sin2 = Math.sin( angle + (Math.PI*0.5) ),
      cos2 = Math.cos( angle + (Math.PI*0.5) ),
      sinC = (sin * this.options.wanderControl),
      sinP = (sin * this.options.wanderPoint),
      cosC = (cos * this.options.wanderControl),
      cosP = (cos * this.options.wanderPoint),
      sinC2 = (sin2 * this.options.wanderControl),
      sinP2 = (sin2 * this.options.wanderPoint),
      cosC2 = (cos2 * this.options.wanderControl),
      cosP2 = (cos2 * this.options.wanderPoint),
      node, nodeTarget;
    this._clear();

    for (i=0,ilen=this.nodes.length; i<ilen; i++) {
      node = this.nodes[i];
      nodeTarget = this.nodesTarget[i];
      switch ( i%4 ) {
        case 0:
          node.x = node.x + (( nodeTarget.x - node.x ) / 4) + sinP;
          node.y = node.y + (( nodeTarget.y - node.y ) / 4) + cosP;
          node.cx = node.cx + (( nodeTarget.cx - node.cx ) / 4) + sinC;
          node.cy = node.cy + (( nodeTarget.cy - node.cy ) / 4) + cosC;
          break;
        case 2:
          node.x = node.x + (( nodeTarget.x - node.x ) / 4) - sinP;
          node.y = node.y + (( nodeTarget.y - node.y ) / 4) - cosP;
          node.cx = node.cx + (( nodeTarget.cx - node.cx ) / 4) - sinC;
          node.cy = node.cy + (( nodeTarget.cy - node.cy ) / 4) - cosC;
          break;
        case 3:
          node.x = node.x + (( nodeTarget.x - node.x ) / 4) + sinP2;
          node.y = node.y + (( nodeTarget.y - node.y ) / 4) + cosP2;
          node.cx = node.cx + (( nodeTarget.cx - node.cx ) / 4) + sinC2;
          node.cy = node.cy + (( nodeTarget.cy - node.cy ) / 4) + cosC2;
          break;
        case 1:
          node.x = node.x + (( nodeTarget.x - node.x ) / 4) - sinP2;
          node.y = node.y + (( nodeTarget.y - node.y ) / 4) - cosP2;
          node.cx = node.cx + (( nodeTarget.cx - node.cx ) / 4) - sinC2;
          node.cy = node.cy + (( nodeTarget.cy - node.cy ) / 4) - cosC2;
          break;
      }

    }

    if (this.changingColor) {
      var colorRatio = (( newTS - this.colorChangeStart ) % this.options.colorPeriod ) / this.options.colorPeriod;
      if (newTS >= this.colorChangeStart + this.options.colorPeriod) {
        this.changingColor = false;
      }
    }

    for (i=0,ilen=this.loopCount; i<ilen; i++) {
      if (this.changingColor) {
        this._drawloop( i * this.nodeCount, this.averageRGB( this.colorSet[this.options.color][i], this.colorSet[this.colorOld][i], colorRatio ) );
      } else {
        this._drawloop( i * this.nodeCount, this.colorSet[this.options.color][i] );
      }
    }

    /* for (i=0,ilen=this.nodes.length; i<ilen; i++) {
    //for (i=32,ilen=40; i<ilen; i++) {
      this._drawdiamond( this.nodes[i] );
    } */

  };

  blobCanvas.prototype._clear = function() {
    this.ctx.clearRect( 0, 0, this.size.width, this.size.height );
  };

  blobCanvas.prototype._drawloop = function( offset, color ) {
    var p0, p1, p2,
      i, ilen;

    p0 = this.nodes[offset];

    this.ctx.beginPath();
    this.ctx.moveTo(p0.x, p0.y);
    for (i=offset,ilen=this.nodeCount+offset-1; i<ilen; i++) {
      p1 = this.nodes[i];
      p2 = this.nodes[i+1];
      this.ctx.bezierCurveTo(p1.cx,p1.cy, (p2.x*2)-p2.cx,(p2.y*2)-p2.cy, p2.x, p2.y);
    }
    this.ctx.bezierCurveTo(p2.cx,p2.cy, (p0.x*2)-p0.cx,(p0.y*2)-p0.cy, p0.x, p0.y);
    this.ctx.closePath();
    this.ctx.fillStyle = color;
    this.ctx.shadowColor = 'rgba(0,0,0,0.1)';
    this.ctx.shadowBlur = 64;
    this.ctx.fill();

    this.ctx.shadowColor = '#000000';
    this.ctx.shadowBlur = 0;

  };


  // Expects input as 'nnnnnn' where each nn is a
  // 2 character hex number for an RGB color value
  // e.g. #3f33c6
  // Returns the average as a hex number without leading #
  blobCanvas.prototype.averageRGB = function (c1, c2, ratio) {

    // Keep helper stuff in closures
    var reSegment = /[\da-z]{2}/gi,
      b1 = c1.match(reSegment),
      b2 = c2.match(reSegment),
      t, c = [];

    if(ratio >= 1) { return c1; }
    if(ratio <= 0) { return c2; }

    for (var i=b1.length; i;) {
      t = Math.floor( (parseInt(b1[--i],16) * ratio) + (parseInt(b2[i],16) * (1-ratio)) ).toString(16);
      c[i] = t.length == 2? '' + t : '0' + t;
    }
    return '#'+c.join('');

  };


  blobCanvas.prototype._drawdiamond = function(p) {
    // Used for DEV only
    this.ctx.beginPath();
    this.ctx.moveTo(p.x - (p.cx - p.x), p.y - (p.cy - p.y));
    this.ctx.lineTo(p.cx, p.cy);
    this.ctx.strokeStyle = 'rgba(0,0,0,0.5)';
    this.ctx.stroke();

    this.ctx.beginPath();
    this.ctx.moveTo(p.x, p.y+5);
    this.ctx.lineTo(p.x+5, p.y);
    this.ctx.lineTo(p.x, p.y-5);
    this.ctx.lineTo(p.x-5, p.y);
    this.ctx.closePath();
    this.ctx.fillStyle = '#000000';
    this.ctx.fill();

    this.ctx.beginPath();
    this.ctx.moveTo(p.cx, p.cy+5);
    this.ctx.lineTo(p.cx+5, p.cy);
    this.ctx.lineTo(p.cx, p.cy-5);
    this.ctx.lineTo(p.cx-5, p.cy);
    this.ctx.closePath();
    this.ctx.fillStyle = '#660000';
    this.ctx.fill();
  };

    site.blobCanvas = blobCanvas;
})(jQuery);
